(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/areas/lobby/lobby.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/areas/lobby/lobby.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const tickets = svs.tickets;
const TicketWithPodium = tickets.next.components.TicketWithPodium;
const preloadPodiumImage = tickets.next.components.podium.preloadPodiumImage;
const Navigation = tickets.next.components.Navigation;
const Services = tickets.next.components.services.Services;
const Categories = tickets.next.components.categories.Categories;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  GridCol = _svs$ui$ReactGrid.GridCol,
  GridRow = _svs$ui$ReactGrid.GridRow;
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const lobbyItemAnimationDelayStepMs = 380;
const getInitialTab = pathname => pathname === '/mer' ? 'more' : 'lobby';
const Lobby = _ref => {
  var _svs$tickets$data$mod, _svs$tickets$data$mod2;
  let history = _ref.history,
    location = _ref.location;
  const _useState = useState(() => getInitialTab(location.pathname)),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  const availableTickets = ((_svs$tickets$data$mod = svs.tickets.data.moduleConfig) === null || _svs$tickets$data$mod === void 0 ? void 0 : _svs$tickets$data$mod.availableTickets) || [];
  const categories = ((_svs$tickets$data$mod2 = svs.tickets.data.moduleConfig) === null || _svs$tickets$data$mod2 === void 0 ? void 0 : _svs$tickets$data$mod2.categories) || [];
  const Hero = svs.tickets.next.components.Hero;
  const openTickets = availableTickets.filter(ticket => ticket.open);
  const heroTicket = openTickets.shift();
  const ticketsToShow = openTickets.length > 0 ? openTickets : availableTickets;
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isPodiumImageLoaded = _useState4[0],
    setIsPodiumImageLoaded = _useState4[1];
  useEffect(() => {
    let isMounted = true;
    const ensurePodiumLoaded = async () => {
      try {
        await preloadPodiumImage();
      } finally {
        if (isMounted) {
          setIsPodiumImageLoaded(true);
        }
      }
    };
    ensurePodiumLoaded();
    return () => {
      isMounted = false;
    };
  }, []);
  useEffect(() => {
    setActiveTab(getInitialTab(location.pathname));
  }, [location.pathname]);
  const selectProduct = ticketInfo => {
    const ticketPath = ticketInfo.alternativeUrl || ticketInfo.type;
    history.push("/valja/".concat(ticketPath));
    window.scrollTo(0, 0);
  };
  const handleTicketClick = (event, ticketInfo) => {
    event.preventDefault();
    selectProduct(ticketInfo);
  };
  const content =
  activeTab === 'lobby' ? React.createElement(React.Fragment, null, isPodiumImageLoaded && React.createElement(GridRow, {
    className: "tickets-next-hero-grid",
    gutter: {
      x: 2,
      y: 4
    }
  }, React.createElement(GridCol, {
    am: {
      col: 8,
      offset: 2
    },
    lg: {
      col: 8,
      offset: 2
    },
    sm: {
      col: 12
    },
    xl: {
      col: 8,
      offset: 2
    },
    xs: 12
  }, React.createElement(Hero, {
    heroTicket: heroTicket,
    onSelectProduct: selectProduct
  }))), React.createElement("div", {
    className: "tickets-next-lobby-list"
  }, isPodiumImageLoaded && React.createElement(GridRow, null, React.createElement(GridCol, {
    am: {
      col: 12
    },
    lg: {
      col: 8,
      offset: 2
    },
    md: {
      col: 8,
      offset: 2
    },
    sm: {
      col: 12
    },
    xl: {
      col: 8,
      offset: 2
    },
    xs: 12
  }, React.createElement(GridRow, {
    className: "tickets-next-lobby-grid",
    gutter: {
      x: 2,
      y: 4
    }
  }, ticketsToShow.map((ticketInfo, index) => {
    var _ticketInfo$skins;
    return React.createElement(GridCol, {
      am: {
        col: 4
      },
      className: "tickets-next-lobby-item",
      key: ticketInfo.type,
      lg: {
        col: 4
      },
      md: {
        col: 4
      },
      sm: {
        col: 6
      },
      style: {
        animationDelay: "".concat(index * lobbyItemAnimationDelayStepMs, "ms")
      },
      xl: {
        col: 4
      },
      xs: 6
    }, React.createElement(TicketWithPodium, {
      image: (_ticketInfo$skins = ticketInfo.skins) === null || _ticketInfo$skins === void 0 || (_ticketInfo$skins = _ticketInfo$skins[0]) === null || _ticketInfo$skins === void 0 ? void 0 : _ticketInfo$skins.image,
      onClick: event => handleTicketClick(event, ticketInfo),
      price: ticketInfo.price,
      ticketType: ticketInfo.title || ticketInfo.name || ticketInfo.type
    }));
  }))))), React.createElement(GridRow, {
    className: "u-flex-justify-content-center",
    gutter: {
      x: 2,
      y: 4
    }
  }, React.createElement(GridCol, {
    lg: {
      col: 8
    },
    xs: 12
  }, categories.length > 0 && React.createElement(Categories, {
    categories: categories
  })))) : React.createElement(Services, null);
  return React.createElement(React.Fragment, null, React.createElement(Navigation, {
    history: history,
    location: location,
    onTabChange: setActiveTab
  }), content);
};
setGlobal('svs.tickets.next.areas.lobby.Lobby', Lobby);

 })(window);